'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _duplex = require('readable-stream/duplex');

var _duplex2 = _interopRequireDefault(_duplex);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _jsonRpcProtocol = require('json-rpc-protocol');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ===================================================================

// Give access to low level interface.
// export * from 'json-rpc-protocol'
// FIXME: work around for https://fabricator.babeljs.io/T2877
{
  (function () {
    var protocol = require('json-rpc-protocol');

    var _loop = function _loop(prop) {
      if (prop !== 'default' && Object.prototype.hasOwnProperty.call(protocol, prop)) {
        (0, _defineProperty2.default)(module.exports, prop, {
          configurable: true,
          enumerable: true,
          get: function get() {
            return protocol[prop];
          }
        });
      }
    };

    for (var prop in protocol) {
      _loop(prop);
    }
  })();
}

// ===================================================================

function makeAsync(fn) {
  return function () {
    var _this = this,
        _arguments = arguments;

    return new _promise2.default(function (resolve) {
      return resolve(fn.apply(_this, _arguments));
    });
  };
}

var parseMessage = function parseMessage(message) {
  try {
    return (0, _jsonRpcProtocol.parse)(message);
  } catch (error) {
    throw _jsonRpcProtocol.format.error(null, error);
  }
};

// Default onMessage implementation:
//
// - ignores notifications
// - throw MethodNotFound for all requests
function defaultOnMessage(message) {
  if (message.type === 'request') {
    throw new _jsonRpcProtocol.MethodNotFound(message.method);
  }
}

function noop() {}

// Starts the autoincrement id with the JavaScript minimal safe integer to have
// more room before running out of integers (it's very far fetched but a very
// long running process with a LOT of messages could run out).
var nextRequestId = -9007199254740991;

// ===================================================================

var Peer = function (_Duplex) {
  (0, _inherits3.default)(Peer, _Duplex);

  function Peer(onMessage) {
    (0, _classCallCheck3.default)(this, Peer);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Peer.__proto__ || (0, _getPrototypeOf2.default)(Peer)).call(this, {
      objectMode: true
    }));

    _this2._handle = makeAsync(onMessage || defaultOnMessage);
    _this2._deferreds = (0, _create2.default)(null);

    // Forward the end of the stream.
    _this2.on('finish', function () {
      this.push(null);
    });
    return _this2;
  }

  (0, _createClass3.default)(Peer, [{
    key: '_getDeferred',
    value: function _getDeferred(id) {
      var deferred = this._deferreds[id];
      delete this._deferreds[id];
      return deferred;
    }

    // Emit buffered outgoing messages.

  }, {
    key: '_read',
    value: function _read() {}

    // Receive and execute incoming messages.

  }, {
    key: '_write',
    value: function _write(message, _, next) {
      var _this3 = this;

      this.exec(String(message)).then(function (response) {
        if (response !== undefined) {
          _this3.push(response);
        }
      }, function (error) {
        _this3.emit('error', error);
      });

      next();
    }
  }, {
    key: 'exec',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(message) {
        var _this4 = this;

        var _ret3, _message, type, _message2, id, _message3, error;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                message = parseMessage(message);

                if (!(0, _isArray2.default)(message)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.delegateYield(_regenerator2.default.mark(function _callee() {
                  var results;
                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          results = [];

                          // Only returns non empty results.

                          _context.next = 3;
                          return _promise2.default.all((0, _map2.default)(message, function (message) {
                            return _this4.exec(message).then(function (result) {
                              if (result) {
                                results.push(result);
                              }
                            });
                          }));

                        case 3:
                          return _context.abrupt('return', {
                            v: results
                          });

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this4);
                })(), 't0', 3);

              case 3:
                _ret3 = _context2.t0;

                if (!((typeof _ret3 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret3)) === "object")) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', _ret3.v);

              case 6:
                _message = message, type = _message.type;

                if (!(type === 'error')) {
                  _context2.next = 15;
                  break;
                }

                _message2 = message, id = _message2.id;

                // Some errors do not have an identifier, simply discard them.

                if (!(id === null)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt('return');

              case 11:
                _message3 = message, error = _message3.error;

                this._getDeferred(id).reject(
                // TODO: it would be great if we could return an error with of
                // a more specific type (and custom types with registration).
                new _jsonRpcProtocol.JsonRpcError(error.message, error.code, error.data));
                _context2.next = 24;
                break;

              case 15:
                if (!(type === 'response')) {
                  _context2.next = 19;
                  break;
                }

                this._getDeferred(message.id).resolve(message.result);
                _context2.next = 24;
                break;

              case 19:
                if (!(type === 'notification')) {
                  _context2.next = 23;
                  break;
                }

                this._handle(message).catch(noop);
                _context2.next = 24;
                break;

              case 23:
                return _context2.abrupt('return', this._handle(message).then(function (result) {
                  return _jsonRpcProtocol.format.response(message.id, result === undefined ? null : result);
                }, function (error) {
                  return _jsonRpcProtocol.format.error(message.id,

                  // If the method name is not defined, default to the method passed
                  // in the request.
                  error instanceof _jsonRpcProtocol.MethodNotFound && !error.data ? new _jsonRpcProtocol.MethodNotFound(message.method) : error);
                }));

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function exec(_x) {
        return _ref.apply(this, arguments);
      }

      return exec;
    }()

    // Fails all pending requests.

  }, {
    key: 'failPendingRequests',
    value: function failPendingRequests(reason) {
      var deferreds = this._deferreds;


      (0, _forEach2.default)(deferreds, function (_ref2, id) {
        var reject = _ref2.reject;

        reject(reason);
        delete deferreds[id];
      });
    }

    /**
     * This function should be called to send a request to the other end.
     *
     * TODO: handle multi-requests.
     */

  }, {
    key: 'request',
    value: function request(method, params) {
      var _this5 = this;

      return new _promise2.default(function (resolve, reject) {
        var requestId = nextRequestId++;

        _this5.push(_jsonRpcProtocol.format.request(requestId, method, params));

        _this5._deferreds[requestId] = { resolve: resolve, reject: reject };
      });
    }

    /**
     * This function should be called to send a notification to the other end.
     *
     * TODO: handle multi-notifications.
     */

  }, {
    key: 'notify',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(method, params) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.push(_jsonRpcProtocol.format.notification(method, params));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function notify(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return notify;
    }()
  }]);
  return Peer;
}(_duplex2.default);

exports.default = Peer;
//# sourceMappingURL=index.js.map